/**
 * 관리자 ④ 분배 공정성
 * ($j.Pages.Admin.Fairness / body data-page-name="Fairness")
 *
 * 유료회원 간 수주 집중도(독식) — 지니계수·상위10%점유·분포·유료vs무료.
 */
import Util from '../../Common/Util';

export default class Fairness {
    constructor() {
        this.bucketChart = null;
        this.$underTable = null;
    }

    initialize() {
        $('#frRefresh').on('click', () => this._load(true));
        $('#frDays, #frCar').on('change', () => this._load());
        this._load();
    }

    async _load(nocache = false) {
        const q = { days: $('#frDays').val() || 30, car_type: $('#frCar').val() || '' };
        try {
            const res = await $.ajax({
                url: '/adm/ajax/stat/fairness/data', type: 'get',
                data: nocache ? { ...q, nocache: 1 } : q
            });
            if (!res.ok) return;
            this._fillCarSelect(res);
            this._renderKpi(res);
            this._renderBuckets(res.buckets);
            this._renderCompare(res.compare);
            if (res.contribution) this._renderContribution(res.contribution);
            if (res.cached_at) {
                const car = res.car_type ? ` · ${res.car_type}` : ' · 전체 업종';
                $('#frCachedAt').text(`집계시각 ${res.cached_at} · 최근 ${res.days}일${car}`);
            }
        } catch (e) {
            console.error('분배 공정성 로드 실패', e);
        }
    }

    /** 업종 목록은 서버 상수(G5_CARTYPE_KR) — 첫 응답에서 한 번만 채운다 */
    _fillCarSelect(r) {
        if (this._carFilled || !r.car_types) return;
        this._carFilled = true;
        const cur = r.car_type || '';
        $('#frCar').html('<option value="">전체</option>' + r.car_types.map(v =>
            `<option value="${v}" ${v === cur ? 'selected' : ''}>${v}</option>`).join(''));
    }

    _renderKpi(r) {
        const gini = Number(r.gini);
        $('#frGini').text(gini).toggleClass('fr-bad', gini >= 0.5);
        $('#frTop10').text(r.top10_share + '%');
        $('#frZero').text(r.zero_pct + '%');
        $('#frZeroSub').text(`${this._c(this._bucketMembers(r.buckets, '0건'))}명 / ${this._c(r.total_members)}명`);
        // 총수주를 그대로 쓰면 기간을 늘릴수록 숫자만 커져 비교가 안 된다 → 월평균으로
        $('#frTotal').text(`${this._c(r.total_wins_pm)} / ${this._c(r.total_members)}`);
        $('#frTotalSub').text(`기간 총 ${this._c(r.total_wins)}건 ÷ ${r.months}개월`);
    }

    _bucketMembers(buckets, name) {
        const b = buckets.find(x => x.bucket === name);
        return b ? b.members : 0;
    }

    _renderBuckets(buckets) {
        const ctx = document.getElementById('frBucketChart').getContext('2d');
        if (this.bucketChart) this.bucketChart.destroy();

        const labels = buckets.map(b => b.bucket);
        const data = buckets.map(b => Number(b.members));
        // 0건은 빨강(이탈위험), 독식 구간(11건+)은 진한색
        const colors = buckets.map(b =>
            b.bucket === '0건' ? '#dc3545' : (b.bucket === '월 11건+' ? '#6610f2' : '#0d6efd'));

        this.bucketChart = new Chart(ctx, {
            type: 'bar',
            data: { labels, datasets: [{ label: '유료회원 수', data, backgroundColor: colors }] },
            options: {
                responsive: true, maintainAspectRatio: false,
                scales: { y: { beginAtZero: true, title: { display: true, text: '회원 수' } } },
                plugins: {
                    legend: { display: false },
                    tooltip: { callbacks: { label: (c) => `${this._c(c.raw)}명` } }
                }
            }
        });
    }

    _renderCompare(cmp) {
        const paid = cmp.paid || { members: 0, wins_pm: 0, avg_wins: 0 };
        const free = cmp.free || { members: 0, wins_pm: 0, avg_wins: 0 };
        $('#frPaidN').text(this._c(paid.members));
        $('#frFreeN').text(this._c(free.members));
        $('#frPaidW').text(this._c(paid.wins_pm));
        $('#frFreeW').text(this._c(free.wins_pm));
        $('#frPaidAvg').text(paid.avg_wins);
        $('#frFreeAvg').text(free.avg_wins);
        const mult = free.avg_wins > 0 ? (paid.avg_wins / free.avg_wins).toFixed(0) : '∞';
        $('#frCmpNote').text(`유료회원이 무료 대비 평균 ${mult}배 수주 — 유료 우선권은 작동. 문제는 유료 내부 독식.`);
    }

    _renderContribution(c) {
        // 발주 구간별 표 (수주/발주 비율)
        const rows = c.buckets.map(b => {
            const ratio = b.ratio == null ? '-' : b.ratio;
            const cls = (b.ratio != null && b.ratio < 0.5) ? 'class="text-danger font-weight-bold"' : '';
            return `<tr><td>${b.bucket}</td><td>${this._c(b.members)}</td><td>${b.baljoo_pm}</td>
                <td>${b.soojoo_pm}</td><td ${cls}>${ratio}</td></tr>`;
        }).join('');
        $('#frContribBuckets tbody').html(rows);

        // 기여 대비 저수주 회원 리스트
        $('#frUnderCount').text(`월평균 발주 ${c.min_baljoo}건+ 중 ${this._c(c.under_rewarded.length)}명`);
        if (this.$underTable) { this.$underTable.destroy(); $('#frUnderTable').empty(); }
        this.$underTable = new DataTable('#frUnderTable', {
            data: c.under_rewarded,
            columns: [
                { data: 'mem_name', title: '이름', render: (v, t, r) => $j.F.Admin.Member.Pop.cell(r.mb_no, v) },
                { data: 'mem_phone', title: '연락처', render: (v) => Util.escapeHtml(v) },
                { data: 'mem_car_type', title: '장비', render: (v) => Util.escapeHtml(v) },
                { data: 'baljoo', title: '월평균 발주' },
                { data: 'soojoo', title: '월평균 수주' },
                {
                    data: 'ratio', title: '수주/발주',
                    render: (v) => Number(v) < 0.5 ? `<span class="text-danger font-weight-bold">${v}</span>` : v
                },
            ],
            order: [[5, 'asc']], // 비율 낮은 순(가장 불만)
            pageLength: 25, lengthChange: true, searching: true, autoWidth: false,
        });
    }

    _c(n) { return Number(n || 0).toLocaleString(); }

    destroy() {
        if (this.bucketChart) { this.bucketChart.destroy(); this.bucketChart = null; }
        if (this.$underTable) { this.$underTable.destroy(); this.$underTable = null; }
    }
}
